import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://hmsc44:8110';

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const expStr = localStorage.getItem('token_exp');
    const exp = expStr ? parseInt(expStr, 10) : 0;
    if (token && exp && Date.now() < exp) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // token expirado ou inexistente
      localStorage.removeItem('token');
      localStorage.removeItem('token_exp');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Só limpa o token se for 401 e não for uma requisição de login
    if (error.response?.status === 401 && 
        !error.config?.url?.includes('/auth/login')) {
      // remove tokens locally
      localStorage.removeItem('token');
      localStorage.removeItem('token_exp');

      // Debug help: log 401s so we can see which requests trigger this
      // (remove or silence in production)
      try {
        // eslint-disable-next-line no-console
        console.warn('API: 401 received for', error.config?.url);
      } catch {}

      // Don't dispatch an auth-logout event while the viewer is open —
      // background image/manifest/file requests may return 401 and cause
      // global logout handling that can trigger navigation/reload.
      if (!window.location.pathname.startsWith('/viewer')) {
        window.dispatchEvent(new CustomEvent('auth-logout'));
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
